import React from 'react';
import {Image, StyleSheet} from 'react-native';
import {loginDesktopBanner} from '../../../assets/images';
import {LandscapePage} from '../../components';
import PortraitView from './index.portrait';

const StudentDetails = (props) => {
  return (
    <LandscapePage
      leftContent={
        <Image source={loginDesktopBanner} style={styles.leftPanelContent} />
      }
      // passing props for navigation props
      rightContent={<PortraitView {...props} />}
    />
  );
};

const styles = StyleSheet.create({
  leftPanelContent: {
    flex: 1,
  },
});

export default StudentDetails;
